import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Report, Page, BrowserOnly } from 'cccisd-laravel-report';
import Loader from 'cccisd-loader';
import { diffWordsWithSpace } from 'diff';
import { reportTemplatePlayer } from 'cccisd-laravel-appdefs';
import style from './style.css';
import { client } from 'cccisd-apollo';
import textQuery from './userText.graphql';
import pawnQuery from './userPawn.graphql';
import { useParams } from 'cccisd-react-router';

// need to know where data comes from
const fakeUserText =
    "One early summer night, you receive a call that an 11-month-old infant is non-responsive and in critical condition. You're riding in the rescue truck, while Firefighter Smith is riding in the fire engine. You are rushing to get there. You can see the lanes. You're thinking of  everything you'll need to do when you arrive at the scene and are getting prepared.\n\nThe truck is passing through busy, urban areas. You see the motel. You pull in behind another fire engine and you can see the flashing lights. The motel lights illuminate the hallway with an amber glow and you can see the yellow doors. (ADDITION) You have been here before. You enter the room and see the little boy in the bathroom to the left. You are the only paramedic on scene. You think to yourself, \"I need to get ready to work.\" You know CPR with infants is more difficult. You are going to get the airway cleared. Firefighter Smith and you put the infant on the stretcher and run back to the truck. You get into the truck and are sitting in the captain's chair with the head of the stretcher at your. To your right, you can see the cabinet with medical equipment.\n\nDoors slam shut and the truck drives to the nearest medical center, which is about six minutes away. You have the airway equipment and take it out of the plastic pouch. Tubes come in all sizes with different variations for infants and adults. You get the blade ready to move the tongue away. There is a mask on his face to squeeze for breathes. You tell them to stop \"bagging.\" You can see his mouth in front of you. You know he needs to get to the hospital as quickly as possible.\n\n You have your blade, light, and proceed. You are crouched on a knee with your head down. You place the blade down inside his mouth. You can see the blade going along the tongue into the throat. You're trying to pull up the tongue to get the airway open. (ADDITION) You can't see the trachea. You continue to lift up, but you can't see the chords to insert the tube. You can't gain access to the lungs. You see the redness and moisture in his mouth; blood is circulating and he is probably still alive. You know where the chords are supposed to be, but you can't find them. You don't want to accidentally blow air into his esophagus because it will reach his stomach. You try again using the same procedure, but you can't see the chords. You take over bagging him. You hear the siren outside and see the bright lights.\n\n The truck pulls up to the hospital. The back door opens and you walk into the entrance. You see people on the right in your periphery. A nurse enters the code on the keypad. You walk in the ER and see the workstation desk area. Nurses and personnel are stationed behind the desk. You move to the trauma bay on the right and see six beds. You put the boy down near the end and you step back. You see the hospital personnel step into action-they've been waiting to receive him. You can't see his head anymore. (ADDITION) His legs are moving from the force of CPR. You watch for a few.";

const Fortress = window.cccisd.fortress;

const DiffReport = props => {
    const { defaultText } = props.settings;
    const [diff, setDiff] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showRemoved, setShowRemoved] = useState(false);
    const [showAdded, setShowAdded] = useState(true);
    const [noUserText, setNoUserText] = useState(false);
    const params = useParams();

    useEffect(() => {
        (async () => {
            let difference = diffWordsWithSpace(defaultText, fakeUserText);
            let pawnId = Fortress.user.acting.id;
            const isGuest = Fortress.user.acting.data_type === 'guest';

            if (isGuest) {
                const respondentHash = params.shortHash;
                try {
                    const result = await client.query({
                        query: pawnQuery,
                        variables: {
                            respondentHash,
                        },
                        fetchPolicy: 'network-only',
                    });
                    pawnId = result.data.roles.anyRole.pawn.pawnId;
                } catch (e) {
                    console.error(e);
                }
            }

            if (!props.isPreview) {
                try {
                    const response = await client.query({
                        query: textQuery,
                        variables: {
                            pawnId,
                        },
                        fetchPolicy: 'network-only',
                    });

                    const userText = response.data.roles.anyRole.assignmentProgress.devTags.UserDiffText;

                    if (!userText) {
                        setNoUserText(true);
                    } else {
                        difference = diffWordsWithSpace(defaultText, userText);
                    }
                } catch (error) {
                    console.error(error);
                }
            }

            setDiff(difference);
            setLoading(false);
        })();
    }, [defaultText]);

    const countInstances = (string, word, i) => {
        return string.split(word).length - 1;
    };

    const renderNewLines = (value, removed, added) => {
        let newArr = value.split('\n');
        newArr.pop();
        const isChange = added || removed;

        return (
            <>
                {isChange ? (
                    <>
                        {newArr.map((line, id) => (
                            <div
                                style={{ height: '18px' }}
                                className={removed ? `${style.removed}` : `${style.added}`}
                                key={id}
                            />
                        ))}
                    </>
                ) : (
                    <>
                        {newArr.map((line, id) => (
                            <div style={{ height: '18px' }} key={id} />
                        ))}
                    </>
                )}
            </>
        );
    };

    if (loading) {
        return <Loader loading />;
    }

    return (
        <Report>
            <Page>
                <div className={style.header}>
                    <div className={style.title}>
                        <h1>Preparing for Trauma Management Therapy</h1>
                        <BrowserOnly>
                            <div className={style.buttons}>
                                <span>Show/Hide:</span>{' '}
                                <button
                                    type="button"
                                    className={`btn btn-secondary ${style.toggle}`}
                                    style={showAdded ? {} : { textDecoration: 'line-through' }}
                                    onClick={() => {
                                        setShowAdded(prevShowAdded => !prevShowAdded);
                                    }}
                                >
                                    Additions
                                </button>{' '}
                                <button
                                    type="button"
                                    className={`btn btn-secondary ${style.toggle}`}
                                    style={showRemoved ? {} : { textDecoration: 'line-through' }}
                                    onClick={() => {
                                        setShowRemoved(prevShowRemoved => !prevShowRemoved);
                                    }}
                                >
                                    Deletions
                                </button>
                            </div>
                        </BrowserOnly>
                    </div>
                    <div className={style.module}>
                        <p>Module</p>
                        <span>4</span>
                    </div>
                </div>
                <div className={style.content}>
                    {diff &&
                        !noUserText &&
                        diff.map(({ removed, added, value }, i) => {
                            if (removed || added) {
                                const newLines = countInstances(value, '\n');

                                if (showRemoved && removed) {
                                    if (newLines) {
                                        return (
                                            <React.Fragment key={i}>{renderNewLines(value, removed)}</React.Fragment>
                                        );
                                    }
                                    return (
                                        <span className={style.removed} key={i}>
                                            {value}
                                        </span>
                                    );
                                }

                                if (showAdded && added) {
                                    if (newLines) {
                                        return (
                                            <React.Fragment key={i}>
                                                {renderNewLines(value, false, added)}
                                            </React.Fragment>
                                        );
                                    }
                                    return (
                                        <span className={style.added} key={i}>
                                            {value}
                                        </span>
                                    );
                                }

                                return null;
                            }
                            const valueWithLines = value.split('\n');
                            return (
                                <React.Fragment key={i}>
                                    {valueWithLines.map((item, id) => {
                                        if (item === '') {
                                            return <div style={{ height: '18px' }} key={id} />;
                                        }
                                        return <span key={id}>{item}</span>;
                                    })}
                                </React.Fragment>
                            );
                        })}
                    {noUserText && (
                        <div className="alert-warning" style={{ padding: '1em' }}>
                            No text was found for comparison.
                        </div>
                    )}
                </div>
            </Page>
        </Report>
    );
};

DiffReport.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
    widgets: PropTypes.object,
    data: PropTypes.object,
    match: PropTypes.object,
};

// reportTemplatePlayer wraps the Report Player with the Filter Bar. This is also where the FilterBar lives and you define your filters. The filters are passed to the Player and Widgets.
export default reportTemplatePlayer({
    filterFields: [],
})(DiffReport);
